// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CTTQ","importantInfo":"styles_importantInfo__6OxrT"};